import React from "react";

const isStandardCode = (code: string): boolean => /^[A-Z]{2}$/.test(code);

interface IProps {
  code: string;
}

const FlagImage: React.FC<IProps> = ({ code }) => {
  if (!isStandardCode(code)) {
    return (
      <span
        style={{ display: "inline-block", width: 20, height: 15, flexShrink: 0 }}
      />
    );
  }
  return (
    <img
      src={`https://flagcdn.com/20x15/${code.toLowerCase()}.png`}
      width={20}
      height={15}
      alt={code}
      style={{ display: "block", width: 20, height: 15, objectFit: "cover", borderRadius: 2, flexShrink: 0 }}
      onError={(e) => {
        (e.target as HTMLImageElement).style.display = "none";
      }}
    />
  );
};

export default FlagImage;
